import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import "@/index.css";
import App, { ROUTE_LOADERS } from "@/App";
import { captureAttribution } from "@/lib/attribution";

// First-touch acquisition capture (Task 8) — runs once per fresh visit, before
// render. First-touch guard inside is a no-op on repeat page loads.
captureAttribution();

const root = ReactDOM.createRoot(
  document.getElementById("__fca_react") || document.getElementById("root"),
);
const render = () => root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>,
);

// Resolve the preloaded route chunk(s) named in this page's <link rel=preload>
// hints before the first render (see lazyRoute in App.js). Never blocks on failure.
const hinted = Array.from(document.querySelectorAll('link[rel="preload"][as="script"]'))
  .map((l) => (l.getAttribute("href") || "").match(/\/static\/js\/(p-[A-Za-z0-9]+)\./))
  .filter(Boolean)
  .map((m) => ROUTE_LOADERS[m[1]])
  .filter(Boolean);

// With a static hero shell in the HTML, index.html's font gate has already decided the
// fonts and painted the shell before injecting this bundle; wait on it anyway in case
// the bundle was loaded by other means (e.g. dev server) so fonts never differ.
const shellPainted = () => {
  if (!document.getElementById("__fca_critical_hero")) return Promise.resolve();
  return new Promise((r) => (window.__fcaFontsWait ? window.__fcaFontsWait(r) : r()));
};

const ready = hinted.length ? Promise.allSettled(hinted.map((load) => load())) : Promise.resolve();
ready.then(shellPainted, shellPainted).then(render, render);
